var map = {
	"./modules_icons/accounting.png": 2153,
	"./modules_icons/asset.png": 7261,
	"./modules_icons/crm.png": 299,
	"./modules_icons/dist.png": 4902,
	"./modules_icons/expenses.png": 785,
	"./modules_icons/fi_control.png": 767,
	"./modules_icons/hcm.png": 8044,
	"./modules_icons/inventory.png": 1085,
	"./modules_icons/mrp.png": 8406,
	"./modules_icons/pos.png": 7231,
	"./modules_icons/project.png": 2993,
	"./modules_icons/purchase.png": 2414,
	"./modules_icons/reporting.png": 9615,
	"./modules_icons/sales.png": 4350,
	"./modules_icons/scm.png": 6784
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3345;